export const DEFAULT_VALUE_XY = { x: 0, y: 0 };
export const ENTER_SCHEDULE_DELAY = 400;
export const PAGE_CHANGE_DELAY = 800;
export const CHECK_ZONES_INTERVAL = 100;
